// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SQ-popup-conent {
  padding: 24px;
  height: calc(100vh - 200px);
}
.SQ-popup-conent h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #2D388B;
}
.SQ-popup-conent p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1F2937;
  margin-bottom: 20px;
}

/* Add this to your component's CSS or the global stylesheet */
.status-button {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  background-color: #f0f0f0;
  color: #000;
}

.status-button:hover {
  background-color: #e0e0e0;
  cursor: pointer;
}

.status-button span {
  margin-left: 4px; /* Adjust the space between the circle icon and text */
}

.gc-agency-handle {
  display: block;
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/app/support/support.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;AACJ;AAAI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAER;AAAI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAER;;AACC,8DAAA;AACD;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAEJ;;AACE;EACE,yBAAA;EACA,eAAA;AAEJ;;AACE;EACE,gBAAA,EAAA,sDAAA;AAEJ;;AAAE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAGJ","sourcesContent":[".SQ-popup-conent{\n    padding: 24px;\n    height: calc(100vh - 200px);\n    h3 {\n        font-style: normal;\n        font-weight: 600;\n        font-size: 20px;\n        line-height: 30px;\n        color: #2D388B;\n    }\n    p{\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px; \n        color: #1F2937;\n        margin-bottom: 20px;\n    }\n}\n /* Add this to your component's CSS or the global stylesheet */\n.status-button {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px;\n    border-radius: 4px; \n    background-color: #f0f0f0;\n    color: #000; \n  }\n  \n  .status-button:hover {\n    background-color: #e0e0e0;  \n    cursor: pointer;\n  }\n  \n  .status-button span {\n    margin-left: 4px; /* Adjust the space between the circle icon and text */\n  }\n  .gc-agency-handle{\n    display: block;\n    font-style: italic;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgb(75 85 99 / 50%);\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
